// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import ViewMembershipPage from '../../components/Individual/Hlutafelagathatttaka/ViewMembership';
// Type imports:
import { IAuthenticationWithId } from '../../types/Types';

const ViewMembership: React.FC = ({...props}) => {
    return (
        <Entrypoint>
            <ViewMembershipPage model={props as IAuthenticationWithId} />
        </Entrypoint>
    );
}

export default ViewMembership;